import { Text } from "@meditect/medibase-components";

export const SalesCannotValidateInvoiceEMECeFError = () => {
  return <Text>La validation de la vente sur la plateforme e-MECeF a généré une erreur</Text>;
};
